export type TimeInterval = 'today' | 'yesterday' | 'lastThirtyDays'

export function getDateRange(interval: TimeInterval): {
  startDate: string
  endDate: string
} {
  const now = new Date()
  let start: Date
  let end: Date
  switch (interval) {
    case 'today': {
      start = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
      )
      end = start
      break
    }
    case 'yesterday': {
      start = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - 1),
      )
      end = start
      break
    }
    case 'lastThirtyDays': {
      start = new Date(
        Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate() - 30,
        ),
      )
      end = new Date(
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
      )
      break
    }
  }
  return {
    startDate: start.toISOString().split('T')[0],
    endDate: end.toISOString().split('T')[0],
  }
}
